import { render, staticRenderFns } from "./platforms.vue?vue&type=template&id=38c03828&scoped=true&"
import script from "./platforms.vue?vue&type=script&lang=js&"
export * from "./platforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c03828",
  null
  
)

export default component.exports